import {Axios as http} from '../axios/axios'

export const getCustomList = (data) => {
  return http({
    url:"/adminapi/getUserList",
    method:'POST',
    data: data
  })
}

export const customerDetail = (data) => {
  return http({
    url: "/adminapi/getUserInfo",
    method:'POST',
    data: data
  })
}

export const resetAvatar= (data) => {
  return http({
    url:"/adminapi/resetAvatar",
    method:'POST',
    data:data
  })
}

export const deleteCustom = (data) => {
  return http({
    url:"/adminapi/deleteUser",
    method:'POST',
    data:data
  })
}

export const updateCustomerStatus = (data) => {
  return http({
    url: "/adminapi/updateUserStatus",
    method:'POST',
    data:data
  })
}

export const updateInviter = (data) => {
  return http({
    url: '/adminapi/updateInviter',
    method:'POST',
    data:data
  })
}

export const searchUsers = (data) => {
  return http({
    url:"/adminapi/searchUsers",
    method:'POST',
    data:data
  })
}
// 增加用户积分 adminapi/increasePoints
export const increasePoints = (data) => {
  return http({
    url:"/adminapi/increasePoints",
    method:'POST',
    data:data
  })
}
// 发送验证码 adminapi/sendVerificationCode
export const sendVerificationCode = (data) => {
  return http({
    url:"/adminapi/sendVerificationCode",
    method:'POST',
    data:data
  })
}
//更新用户手机号 adminapi/updateUserPhone
export const updateUserPhone = (data) => {
  return http({
    url:"/adminapi/updateUserPhone",
    method:'POST',
    data:data
  })
}
